import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LicensingService } from '../licensing.service';
import { AppSettings } from 'src/app/_helpers/app.settings';
import { HelperService } from 'src/app/_helpers/helper.service';
@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.scss']
})
export class ViewCustomerComponent implements OnInit{
  model: any = {
  };
  constructor(
    public modalRef: BsModalRef,
    public licensingService: LicensingService,
    public helper: HelperService
  ) {

  }
  ngOnInit(): void {
    this.fetchLicenseDetail();
    
  }
  fetchLicenseDetail() {
    this.helper.showLoader(true);
    let data = {customerCode: this.model.customerCode};
    
    this.licensingService.fetchLicenseDetail({
      data: data,
      success: (response: any) => {
        if(response) {
          let data = response;
          this.model.code = data.customerCode;
          this.model.licenseType = data.isPaidLicense ? "Paid" : "Trial";
          this.model.scriptedcheck = data.scripted;
          this.model.scriptlesscheck = data.scriptless;
          this.model.randomTestDataCheck = data.randomTDG;
          this.model.designCoPilotCheck = data.designCopilot;
          this.model.selectedUtilities = data.utilities;
          this.model.startDate = this.helper.convert(data.startDate, AppSettings.DD_MM_YYYY);
          this.model.endDate = this.helper.convert(data.endDate, AppSettings.DD_MM_YYYY);
          this.model.userCount = data.userCount;
          this.model.totalCost = data.totalCost;
          this.model.utilityList = this.getUtilityNames(data.utilities);
          this.model.isActive = data.isActive;
        }
        this.helper.showLoader(false);
      },
      error: (error: any) => {
        this.helper.showLoader(false);
        console.log(error);
      }
    });
  }
  getUtilityNames(list: any) {
    let names: any = [];
    if(list?.length) {
      list.forEach((rec: any) => {
        names.push(rec.name);
      });
    }
    return names;
  }
}
